import BusinessError from '../util/BusinessError';
import { SITUACAO_ACORDAO } from './SituacaoAcordao';
import SituacaoJulgamentoProcessoBusiness from './SituacaoJulgamentoProcessoBusiness';

/**
 * @classdesc Agrega as regras semânticas relacionadas às situações de acórdão.
 * @readonly
 */
export default class SituacaoAcordaoBusiness {
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO =
        'Não foi possível identificar a situação do acórdão para o fuxo de assinatura/publicação.';
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO_PROCESSO_NAO_JULGADO =
        'As situações de acórdão para processos não julgados são ignoradas.';

    static getSituacaoAcordaoEscopoPublicacao(registro) {
        // [TODO] Esse tratamento deveria ser feito na consulta (backend), onde as situações de acórdão deveriam ser restritas à sessão, independentemente do processo estar ou não julgado
        if (!SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(registro?.resultadoJulgamento)) {
            throw new BusinessError(
                `${SituacaoAcordaoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO_PROCESSO_NAO_JULGADO} [${registro.numeroProcesso}]`
            );
        }

        /*
         * [REVIEW] SE-12043
         */

        if (!registro.acordaoAssinado && registro.dataAssinaturaSistemaOrigem) {
            return SITUACAO_ACORDAO.ASSINADO_ORIGEM;
        }

        if (registro.informacoesAdicionais.dataDevolucaoAcordao) {
            return SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO;
        }

        if (registro.acordaoAssinado) {
            if (registro.acordaoValidado) {
                return SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO;
            } else {
                return SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO;
            }
        } else {
            if (!registro.acordaoObrigatorio) {
                return SITUACAO_ACORDAO.NAO_PUBLICAVEL;
            }

            if (!registro.informacoesAdicionais.dataAssinaturaAcordao && !registro.dataAssinaturaSistemaOrigem) {
                return SITUACAO_ACORDAO.NAO_ASSINADO;
            }
        }

        throw new BusinessError(
            `${SituacaoAcordaoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO} [${registro.numeroProcesso}]`
        );
    }

    static isPublicacaoAcordaoObrigatoria(registro) {
        const marcacaoManualPublicacaoAcordao = !!(
            registro?.informacoesAdicionais?.marcadorAcordaoObrigatorio === true ||
            registro?.informacoesAdicionais?.marcadorAcordaoObrigatorio === false
        );

        const isProcessoApreciado = SituacaoJulgamentoProcessoBusiness.isProcessoApreciado(
            registro?.resultadoJulgamento
        );

        const isProcessoJulgado = SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(registro?.resultadoJulgamento);

        if (marcacaoManualPublicacaoAcordao) {
            return registro.informacoesAdicionais.marcadorAcordaoObrigatorio;
        }

        if (registro.acordaoObrigatorio !== false && isProcessoApreciado && !isProcessoJulgado) {
            return false;
        }

        return registro.acordaoObrigatorio !== false;
    }
}
